import { withTranslation } from 'react-i18next';
import { LoginBlockedUser } from './LoginBlockedUser.layout';

export default withTranslation('login')(LoginBlockedUser);
